import { usePreferenceStore, useLocaleStore } from '@/stores'
import { isElectron } from '@/utils/env'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

export function useSoftware() {
  const { t } = useLocaleStore()
  const isElectronEnv = isElectron()
  const version = ref()
  const getVersion = async () => {
    if (!isElectronEnv) {
      return
    }
    version.value = await window.electronAPI?.getAppVersion()
  }
  const initSoftwareData = async () => {
    await getVersion()
  }

  const preferenceStore = usePreferenceStore()
  const { start } = storeToRefs(preferenceStore)
  const softwareData = computed(() => {
    if (!isElectronEnv) {
      return null
    }

    const data = [
      {
        name: t('home.overview.softwareData.currentVersion'),
        value: version.value,
      },
      {
        name: t('home.overview.softwareData.autoStart'),
        value: start.value.auto
          ? t('home.overview.softwareData.on')
          : t('home.overview.softwareData.off'),
      },
    ]

    if (!data.length) return null

    return {
      title: t('home.overview.softwareData.title'),
      data,
    }
  })
  return {
    softwareData,
    initSoftwareData,
  }
}
